import { ref } from 'vue';

// Uma seção da página Atendimento: pede a própria rota, guarda a resposta e diz a
// própria falha — a falha de uma seção não apaga as outras. Resposta que chega
// fora de ordem (filtro trocado rápido) é descartada: só a última vale.
//
// `loadIfStale(key, …)` pede só se a chave (o filtro do pedido) mudou desde o
// último: voltar a uma aba não pede de novo, e trocar o filtro só invalida — a
// aba escondida pede quando for aberta. O pedido que falhou não conta como
// carregado, e abrir a aba de novo tenta outra vez. `error` guarda o erro do
// último pedido, para quem mostra o motivo que o servidor mandou.
export function useAtendimentoSection(fetcher) {
  const data = ref(null);
  const loading = ref(false);
  const failed = ref(false);
  const error = ref(null);
  let lastRequest = 0;
  let loadedKey = null;

  const load = async (...args) => {
    lastRequest += 1;
    const request = lastRequest;
    loading.value = true;
    try {
      const { data: response } = await fetcher(...args);
      if (request !== lastRequest) return;
      data.value = response;
      failed.value = false;
      error.value = null;
    } catch (caught) {
      if (request !== lastRequest) return;
      data.value = null;
      failed.value = true;
      error.value = caught;
      loadedKey = null;
    } finally {
      if (request === lastRequest) loading.value = false;
    }
  };

  const loadIfStale = (key, ...args) => {
    if (key === loadedKey) return Promise.resolve();
    loadedKey = key;
    return load(...args);
  };

  const invalidate = () => {
    loadedKey = null;
  };

  return { data, loading, failed, error, load, loadIfStale, invalidate };
}
